import React from "react";
import "../Footer.css";
import { track } from "../../../services/analytics";

interface SponsorLogosProps {
  logos: {
    cemig: string;
    cemigsaude: string;
    gasmig: string;
    taesa: string;
    indi: string;
    efficientia: string;
  };
}

const SponsorLogos: React.FC<SponsorLogosProps> = ({ logos }) => {
  const trackSponsor = (identificador: string) => {
    track("link_externo_clique", {
      identificador,
      categoria: "patrocinadora",
    });
  };

  return (
    <div className="footer-sponsors-container">
      {/* Primeira linha de logos */}
      <div className="footer-sponsors-row">
        <div className="footer-sponsor-item">
          <a
            href="https://www.cemig.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-sponsor-link"
            onClick={() => trackSponsor("cemig")}
          >
            <img
              src={logos.cemig}
              alt="CEMIG"
              className="footer-sponsor-logo"
            />
          </a>
        </div>
        <div className="footer-sponsor-item">
          <a
            href="https://www.cemigsaude.org.br/site/home"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-sponsor-link"
            onClick={() => trackSponsor("cemigsaude")}
          >
            <img
              src={logos.cemigsaude}
              alt="CEMIG Saúde"
              className="footer-sponsor-logo"
            />
          </a>
        </div>
        <div className="footer-sponsor-item">
          <a
            href="http://www.gasmig.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-sponsor-link"
            onClick={() => trackSponsor("gasmig")}
          >
            <img
              src={logos.gasmig}
              alt="GASMIG"
              className="footer-sponsor-logo"
            />
          </a>
        </div>
      </div>

      {/* Segunda linha de logos */}
      <div className="footer-sponsors-row">
        <div className="footer-sponsor-item">
          <a
            href="http://institucional.taesa.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-sponsor-link"
            onClick={() => trackSponsor("taesa")}
          >
            <img
              src={logos.taesa}
              alt="TAESA"
              className="footer-sponsor-logo"
            />
          </a>
        </div>
        <div className="footer-sponsor-item">
          <a
            href="https://www.investminas.mg.gov.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-sponsor-link"
            onClick={() => trackSponsor("indi")}
          >
            <img
              src={logos.indi}
              alt="Invest Minas"
              className="footer-sponsor-logo"
            />
          </a>
        </div>
        <div className="footer-sponsor-item">
          <a
            href="https://cemigsim.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-sponsor-link"
            onClick={() => trackSponsor("efficientia")}
          >
            <img
              src={logos.efficientia}
              alt="CEMIG SIM"
              className="footer-sponsor-logo"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default SponsorLogos;
